var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2344_1860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45711 19.4571L4.56534 20.5653C4.94698 20.947 5.56263 20.9569 5.95638 20.5878L12.8646 14.1113C13.1057 13.8853 13.441 13.7926 13.767 13.8475C15.0762 14.0678 18.5232 14.4767 20 13C22.309 10.6912 21.2694 6.79607 20.8765 5.60598C20.8202 5.43555 20.6088 5.39118 20.4819 5.51809L16.4571 9.54289C16.0666 9.93342 15.4334 9.93342 15.0429 9.54289L14.4205 8.92046C14.0444 8.54435 14.0285 7.93964 14.3843 7.54431L17.9799 3.55009C18.1041 3.4121 18.0407 3.19633 17.8591 3.15801C16.7116 2.91595 13.3047 2.4004 11.25 4.25C9.35234 5.95822 10.0479 8.81924 10.4929 10.098C10.6315 10.4962 10.5512 10.9488 10.2531 11.2469L3.45711 18.0429C3.06658 18.4334 3.06658 19.0666 3.45711 19.4571Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2344_1860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.925a80b675cbe95ea3c36d278ebf2886.svg";
export { ForwardRef as ReactComponent };